<template>
	<inertia-head title="Gold Class" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Gold Class</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Gold Membership Training
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div
			v-if="$page.props.user.current_rank === 'SILVER'"
			class="alert alert-warning"
		>
			<p class="fw-semibold mb-0">UPGRADE TO GOLD or HIGHER</p>
		</div>
		<div v-else class="row">
			<div class="col-lg-8">
				<div class="block">
					<div class="block-content block-content-full p-0">
						<VimeoIframe :video-link="featured.video_id" />
					</div>
					<div class="block-content block-content-full text-center">
						<h6>{{ featured.title }}</h6>
					</div>
					<div
						class="block-content block-content-full border-top d-flex justify-content-between"
					>
						<InertiaLink
							v-if="featured.previous"
							:href="`/member/my-courses/gold-class?${featured.previous}`"
							class="btn btn-alt-secondary"
						>
							Previous
						</InertiaLink>
						<InertiaLink
							v-if="featured.next"
							:href="`/member/my-courses/gold-class?${featured.next}`"
							class="btn btn-alt-primary"
						>
							Next
						</InertiaLink>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<a
					class="block block-link-shadow text-center mb-1"
					href="javascript:void(0)"
				>
					<div class="block-header border-bottom">
						<h3 class="block-title">Instructor</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="push">
							<img
								class="img-avatar"
								src="/media/avatars/avatar10.jpg"
								alt=""
							/>
						</div>
						<div class="fw-semibold mb-1">{{ featured.author }}</div>
						<div class="fs-sm text-muted">
							You now have the proper tools. Now let's get to the next step!
						</div>
					</div>
				</a>
				<div class="block">
					<div class="block-content p-0">
						<div class="accordion accordion-flush" id="coursesAccordion">
							<!-- Courses -->
							<div
								v-for="header in headers"
								:key="header.counter"
								class="accordion-item"
							>
								<h2
									class="accordion-header bg-primary"
									:id="`course-${header.counter}`"
								>
									<button
										class="accordion-button bg-black-25"
										type="button"
										data-bs-toggle="collapse"
										:data-bs-target="`#course-collapse-${header.counter}`"
										aria-expanded="true"
										:aria-controls="`course-collapse-${header.counter}`"
									>
										{{ header.title }}
									</button>
								</h2>
								<div
									:id="`course-collapse-${header.counter}`"
									class="accordion-collapse collapse"
									:class="{ show: featured.module == header.module }"
									:aria-labelledby="`course-${header.counter}`"
									data-bs-parent="#coursesAccordion"
								>
									<div class="accordion-body">
										<table
											class="table table-sm table-borderless table-vcenter"
										>
											<tbody>
												<tr
													v-for="course in courses[header.module]"
													:key="course.counter"
												>
													<td
														class="fs-sm"
														:class="{
															'table-primary':
																featured.counter == course.counter,
														}"
													>
														<InertiaLink
															:href="
																route('member.my-courses.gold-class', {
																	mod: course.module,
																	vid: course.video,
																})
															"
															class="text-dark"
														>
															{{ course.title }}
														</InertiaLink>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		featured: Object,
		courses: Object,
		headers: Object,
	},
}
</script>
